<template>
<div class="card">
    <h6>YOUR CURRENT ENERGY SUPPLY</h6>
    <h4>{{ defaultSupplier == quote.electricitySupplierId ? 'Your electricity is currently provided by' : 'Who is your current electricity supplier?' }}</h4>

    <loader :show="loading.suppliersElectricity"></loader>
    <div class="form-group" v-if="!loading.suppliersElectricity">
        <div class="col-sm-7">
            <div class="row" v-show="quote.electricitySupplierId">
                <div class="col-xs-6 col-md-5">
                    <div class="company-logo _margin-top-10 _margin-bottom-20" :class="`supplier-${quote.electricitySupplierId}`"></div>
                </div>

                <div class="col-xs-6 col-md-7">
                    <uiv-btn class="_margin-top-10" type="link" @click="quote.electricitySupplierId = null">
                        Change
                    </uiv-btn>
                </div>
            </div>

            <div v-show="!quote.electricitySupplierId">
                <form-label id="supplierElectricity">Select your supplier</form-label>
                <validation-messages label="Supplier" :$v="$v.electricitySupplierId">
                  <select-list id="supplierElectricity"
                    :list="supplierElectricityList"
                    v-model="quote.electricitySupplierId"
                    value-key="id"
                    label-key="name"
                    :error="$v.electricitySupplierId.$error"
                    @change="onChooseSupplier"
                  />
                </validation-messages>
            </div>
        </div>
    </div>

    <div v-show="quote.electricitySupplierId">
      <loader :show="loading.tariffsElectricity"></loader>
      <div class="form-group _margin-bottom-30" v-if="!loading.tariffsElectricity">
          <div class="col-sm-7">
            <form-label id="tariffElectricity">
              {{ quote.electricityTariff.name ? 'Your tariff' : 'Select your plan' }}
              <button type="button" class="btn-i" v-if="!quote.electricityTariff.name" v-uiv-tooltip.right="'You will find what plan you\'re on by looking at your latest bill'">i</button>
            </form-label>
            <validation-messages label="Tariff" :$v="$v.electricityTariff.id">
               <select-list id="tariffElectricity"
                  v-model="quote.electricityTariff.id"
                  value-key="id"
                  label-key="name"
                  :list="tariffElectricityList"
                  :error="$v.electricityTariff.id.$error"
                  @change="onChooseTariff"
               />
            </validation-messages>
          </div>
      </div>

      <div class="form-group" v-show="quote.electricityTariff.isFixedFromEnergyStartDate">
          <div class="col-sm-7">
            <form-label id="electricityTariffValidToDate">Tariff End Date</form-label>
            <validation-messages label="Tariff End Date" :$v="$v.electricityTariffValidToDate">
               <date-field
                  id="electricityTariffValidToDate"
                  v-model="quote.electricityTariffValidToDate"
                  :error="$v.electricityTariffValidToDate.$error"
               />
            </validation-messages>
          </div>
      </div>
    </div>
</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'SupplierTariffElectricity',
  data () {
    return {
      requesting: false
    };
  },
  props: {
    $v: Object
  },
  computed: {
    ...mapState({
      quote: ({ quote }) => quote,
      supplierElectricityList: ({ lookups }) => lookups.suppliersElectricity,
      tariffElectricityList: ({ lookups }) => lookups.tariffsElectricity,
      loading: ({ lookups }) => lookups.requesting,
      defaultSupplier: ({ quote }) => {
          const address = quote.address.parts;
          if(!address) return false;
          const elecdetails = address.elecdetails.find(({ isDomestic }) => isDomestic) || {};

          return elecdetails.mugSupplierId ? elecdetails.mugSupplierId : false;
      }
    })
  },
  watch: {
    tariffElectricityList (value) {
      const defaultTariffFound = value.find(({ isDefaultOrStandard }) => isDefaultOrStandard);

      if (defaultTariffFound) {
        this.onChooseTariff(defaultTariffFound.id);
      }
    }
  },
  methods: {
     ...mapActions({
        getTariffs: 'lookups/getTariffs'
     }),
     async onChooseSupplier (id) {
        this.quote.electricityTariff = {};
        this.quote.electricitySupplierId = id;
        this.quote.electricityTariffValidToDate = null;
        await this.getTariffs({ fuelType: 'electricity', supplierId: id });
     },
     onChooseTariff (tariffId) {
        if (!tariffId) return;
        const selected = this.tariffElectricityList.find(({ id }) => id == tariffId);
        this.quote.electricityTariff = { ...selected };

        if (!selected.isFixedFromEnergyStartDate) {
           this.quote.electricityTariffValidToDate = null;
        }
     }
  }
};
</script>

<style lang="scss">
</style>
